import type {BenchlingSelection} from 'notebook/mediocre/selection/SelectionStore';
import type {StructuredTableMappingActionOptions} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingConstants';
import type {TableValidationResponse} from 'notebook/structured-tables/StructuredTableApiConstants';
import type {TableCellEditorPosition} from 'notebook/tables/constants/CellConstants';
import type {TableIndex} from 'notebook/tables/constants/TableSelectionConstants';
import type {CellInsertMode} from 'notebook/tables/excess/FormulaUtil';
import type {MultidocTableOpMap, TableOpDiffMap} from 'notebook/tables/excess/ops/TableOpConstants';
import type {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export const STRUCTURED_TABLE_EVENT_PAYLOADS = {
  STRUCTURED_TABLE_INVOKE_MAPPINGS: {} as {
    fileId: string;
    sourceTableProvenanceUuid: string;
    options: StructuredTableMappingActionOptions;
  },
  STRUCTURED_TABLE_VALIDATION_ERRORS: {} as {
    entryId: string;
    validationErrorResponse: TableValidationResponse;
  },

  EXCESS_DELETE_SNAPSHOTTED_RESOLUTIONS_FOR_TABLE: {} as {
    itemId: string;
    provenanceUuid: string;
    tableOp: TableOpDiffMap;
    lookupConfigIds?: Array<string>;
  },
  EXCESS_FORCE_EVALUATION: {} as {
    fileId: string;
    bumpVersion?: boolean;
    multidocTableOp?: MultidocTableOpMap;
  },

  SPREADSHEET_SET_FORMULA: {} as {
    tableNamespace: string;
    tableName: string | null;
    documentName: string | null;
    editing: boolean;
    index: TableIndex | null;
    cellInsertMode?: CellInsertMode;
    fileId: string | null;
    formula: string;
    typedValue: TypedValue | null;
    selection: BenchlingSelection | null;
  },
  SPREADSHEET_SET_TYPED_VALUE: {} as {
    typedValue: TypedValue | null;
  },
  SPREADSHEET_SET_CELL_EDITOR_POSITION: {} as {
    cellEditorPosition: TableCellEditorPosition | null;
  },
} as const;

export type StructuredTableEventPayload = typeof STRUCTURED_TABLE_EVENT_PAYLOADS;
